import { makeModuleI18nSelector, makeModuleStateSelector } from "@client/content/selectors";
import { type ControlFormField } from "@client/controls/Form/component";
import TextArea from "@client/controls/Inputs/TextArea/component";
import AddressInput from "@client/controls/Inputs/TextInput/Address/component";
import TextInput from "@client/controls/Inputs/TextInput/component";
import { combinedSettingsSelector, getSettingValueSelector, TargetSelector } from "@client/selectors";
import { fieldValidation } from "@common/controls/Form/Field/lib";
import React from "react";
import { createSelector } from "reselect";
import { defaultState } from "./reducer";
import { type ContactForm } from "./types";

export const localStateSelector = makeModuleStateSelector<ContactForm.State>(defaultState, defaultState);

export const makeFieldsSelector = () => {
  const moduleI18Selector = makeModuleI18nSelector();
  const messageHeightSelector = getSettingValueSelector(TargetSelector.Entity, "messageHeight");

  return createSelector([moduleI18Selector, messageHeightSelector], (i18n, messageHeight): ControlFormField[] => [
    {
      name: "name",
      label: i18n.name,
      isRequired: true,
      Component: TextInput,
      defaultValue: "",
      componentOpts: {
        autoComplete: "given-name"
      }
    },
    {
      name: "email",
      label: i18n.email,
      isRequired: true,
      Component: AddressInput,
      validation: fieldValidation.email,
      defaultValue: ""
    },
    { name: "subject", label: i18n.subject, isRequired: true, Component: TextInput, defaultValue: "" },
    {
      name: "message",
      label: i18n.message,
      Component: TextArea,
      componentOpts: { rows: 10, cols: 10, style: { height: messageHeight, resize: "none" } },
      isRequired: true,
      defaultValue: ""
    }
  ]);
};

export const makeFormStyleSelector = () => {
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    "horizontalGap",
    "maxHeight",
    "verticalGap"
  ]);

  return createSelector(
    [settingsSelector],
    (settings): React.CSSProperties => ({
      maxHeight: settings.maxHeight,
      columnGap: settings.horizontalGap,
      rowGap: settings.verticalGap
    })
  );
};
